import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_225_2351)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.4315 13.2979C30.6812 13.5362 30.6904 13.9319 30.4521 14.1815L17.3271 27.9315C17.2109 28.0533 17.0505 28.123 16.8823 28.125C16.714 28.1269 16.5521 28.0609 16.4331 27.9419L9.55806 21.0669C9.31398 20.8229 9.31398 20.4271 9.55806 20.1831C9.80214 19.939 10.1979 19.939 10.4419 20.1831L16.8646 26.6057L29.5479 13.3185C29.7862 13.0688 30.1819 13.0596 30.4315 13.2979Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M38.125 20C38.125 9.98984 30.0102 1.875 20 1.875C9.98984 1.875 1.875 9.98984 1.875 20C1.875 30.0102 9.98984 38.125 20 38.125C30.0102 38.125 38.125 30.0102 38.125 20ZM39.375 20C39.375 30.7005 30.7005 39.375 20 39.375C9.29948 39.375 0.625 30.7005 0.625 20C0.625 9.29948 9.29948 0.625 20 0.625C30.7005 0.625 39.375 9.29948 39.375 20Z",
			fill: "currentColor"
		})]
	})
});
export default SvgCheckCircle;
